import Model from '../models/ligne.model'

export default {
  addLigne: ({ POST }, ligne) =>
    new Promise((resolve, reject) => {
      if (!(ligne instanceof Model)) {
        return reject(new Error(
          `Erreur paramètre : ${Model.constructor.name} attendu mais reçu "${ligne.constructor.name}"`
        ))
      }
      return POST(`caisses/${ligne.getCaisseId()}/lignes`, ligne)
        .then(reponse => {
          const data = reponse.data
          if (reponse.status === 200 && data.id) {
            const model = new Model(data)
            resolve(model)
          } else {
            reject(reponse.status)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
}
